'use client'

import type { JSX } from 'react'

import { TransactionSide } from '@marketplace-web/complaints/complaints-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

type RenderProps = {
  transactionId?: number
  complaintId?: string | null
  userSide?: TransactionSide | null
  conversationTransactionId: number | undefined
  conversationTransactionIsBundle: boolean | undefined
}

type Props = {
  children: (props: RenderProps) => JSX.Element
}

const ComplaintActionConversationWrapper = ({ children }: Props) => {
  const { conversation, transaction } = useConversationContext()
  const transactionId = transaction?.id
  const complaintId = transaction?.complaintId
  const userSide = transaction?.userSide
  const conversationTransactionId = conversation?.transaction?.id
  const conversationTransactionIsBundle = conversation?.transaction?.isBundle

  return children({
    transactionId,
    complaintId,
    userSide,
    conversationTransactionId,
    conversationTransactionIsBundle,
  })
}

export default ComplaintActionConversationWrapper
